import styled, {css} from "styled-components";
import { Grid, Section as SectionStyle, Container as ContainerStyles, SectionTitle, Btn, BtnFlex, BtnWhite } from "../ReUsableStyles";
import {Link} from 'react-router-dom';
import { Link as LinkScroll } from "react-scroll";

export const Section = styled.section`
    ${SectionStyle};
    text-align: center;
`;

export const Container = styled.div`
    ${ContainerStyles};
    ${Grid};
`;

export const ProjectBg = styled.div`
    background-color: var(--first-color-second);
    padding-top: 3rem;
`;

export const Data = styled.div`
    
`;

const TitleDescColor = css`
    color: #fff;
`;

export const ProjectTitle = styled.h2`
    ${SectionTitle};
    font-size: var(--h2-font-size);
    margin-bottom: var(--mb-0-75);
    ${TitleDescColor};
`;
export const Desc = styled.p`
    margin-bottom: var(--mb-1-5);
    ${TitleDescColor};
`;
export const Button = styled(LinkScroll)`
    ${Btn};
    ${BtnFlex};
    ${BtnWhite};
`;
export const Img = styled.img`
    width: 232px;
    justify-self: center;
`;